/**
 * URLからサイトタイトルを取得する
 * @param {string} url サイトのURL
 * @returns {Promise<string>} サイトのタイトル
 */
export async function fetchSiteTitle(url) {
  try {
    const apiUrl = `https://unxo.net/api/get-title.php?url=${encodeURIComponent(url)}`;
    
    const response = await fetch(apiUrl);
    
    if (!response.ok) {
      throw new Error(`サイト情報の取得に失敗しました: ${response.status} ${response.statusText}`);
    }
    
    const text = await response.text(); // まずテキストとして取得
    
    try {
      const data = JSON.parse(text);
      if (data && data.title) {
        return data.title;
      }
    } catch (parseError) {
      console.error('JSONのパースに失敗しました:', parseError);
      throw new Error('APIの応答が不正です');
    }
    
    return '';
  } catch (error) {
    console.error('サイトタイトル取得エラー:', error);
    return '';
  }
}

/**
 * URLからファビコンを取得する
 * @param {string} url サイトのURL
 * @returns {string} ファビコンのURL
 */
export function getFaviconUrl(url) {
  try {
    // URLからドメインを抽出
    const domain = new URL(url).hostname;
    return `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;
  } catch (error) {
    console.error('ファビコンURL生成エラー:', error);
    return '/bookmark.svg'; // デフォルトアイコン
  }
}